<template>
  <div id="app-back-top" v-on:click="backTop()"></div>
</template>

<script>
export default {
  name: "BackTop",
  mounted() {
    const backTop = document.getElementById("app-back-top");
    setInterval(function () {
      if (window.scrollY < 100) {
        backTop.style.display = "none"
      } else {
        backTop.style.display = "block"
      }
    }, 500)
  },
  methods: {
    backTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

#app-back-top {
  position: fixed;
  height: 50px;
  width: 50px;
  bottom: 100px;
  right: 50px;
  text-align: center;
  background-image: url("../../assets/img/backTop.png");
  cursor: pointer;
}

#app-back-top:hover {
  transition: all 450ms ease-out;
  transform: rotate(180deg);
}

</style>